var exports = {
  "kL": "x234b8571--fce262--container",
  "Sl": "x234b8571--fce262--image",
  "OS": "x234b8571--fce262--more",
  "MK": "x234b8571--fce262--menu",
  "ed": "x234b8571--fce262--disclaimer",
};

module.exports = exports;
